import { Link } from 'react-router-dom';
import type { Service } from '@bharat-consultancy/shared';

export function ServiceCard({ service }: { service: Service }) {
  return (
    <Link
      to={`/services/${service.slug}`}
      className="group flex flex-col rounded-lg border border-line bg-white p-6 shadow-stamp transition-all hover:-translate-y-0.5 hover:shadow-stamp-lifted"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-seal-blue/10 text-2xl">
        📄
      </div>
      <h3 className="mt-4 font-display text-lg font-semibold text-ink group-hover:text-seal-blue">
        {service.title}
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/60">{service.shortDescription}</p>

      {/* Pricing intentionally removed per client request — see
          lib/bookingFlags.ts. Only "Learn More" remains; pricing lived
          in a "Starting at ₹X" block here previously (service.startingPrice
          is still populated in the DB/API, just not rendered). */}
      <div className="stub-divider mt-5 flex items-center justify-end pt-4">
        <span className="text-sm font-medium text-seal-blue group-hover:underline">Learn More →</span>
      </div>
    </Link>
  );
}
